import { snapshot } from 'valtio'
import { MIN_PASSWORD_LENGTH } from '../../../../../shared/utils/authUtils'
import { proxyChangePassword } from '../../../../../shared/proxies/changePasswordProxy'
import { isPasswordInvalid } from '../../../../../shared/utils/stringUtils'
import { FormFieldNamesEnum } from './formFieldNamesEnum'

export const validators: { [key in FormFieldNamesEnum]?: (arg0: string) => string | null } = {
  [FormFieldNamesEnum.Password]: val => {
    if (!val) { return 'Required' }
    return isPasswordInvalid(val)
  },
  [FormFieldNamesEnum.PasswordConfirmation]: val => {
    if (!val) { return 'Value is Required' }
    if (val.length < MIN_PASSWORD_LENGTH) { return 'Too short' }
    const { formValues } = snapshot(proxyChangePassword)
    if (val !== formValues[FormFieldNamesEnum.Password]) { return 'Must match' }
    return null
  }
}
